import { Button, Chip, cn, ContentBlock, Grid2, ImgLazyLoader, LazyImg, Typography } from '@riac/design-system';
import React from 'react';
export const DetailPageRelatedItemsSection = ({ itemInfo }: any) => {
  return (<div className=''>
    <Grid2 className='pt-20'>
      <div className='max-w-[994px] flex flex-col gap-3 xl:gap-5 m-auto'>
        <Typography weight='medium' align='center' color='text-light'>
          Find More
        </Typography>
        <Typography expressive size='xl' heading weight='bold' align='center' color='text'>
          Related Items
        </Typography>
      </div>
    </Grid2>
    <Grid2 className='pb-20'>
      <div className='grid grid-cols-1 md:grid-cols-3 xl:grid-cols-4 gap-3 items-stretch justify-stretch'>
        {itemInfo?.relatedItems?.slice(0, 4)?.map((relatedItem, index) => (
          <Button
            to={`/detail/${relatedItem.auctionId}/${relatedItem.lotNumber}`} unstyled key={relatedItem.lotNumber + relatedItem.auctionId + relatedItem.webTitle}
            className='flex flex-col gap-2 group last:hidden xl:last:flex max-w-[256px] p-1 mx-auto'
          >
            <LazyImg
              src={`${
                      window.CDN_PATH
                    }${
                      relatedItem.auctionId
                    }/255X159/${
                      relatedItem.lotNumber
                    }.jpg?cachebust=${
                      Math.random()
                    }`}
              alt={ relatedItem.webTitle }
              className='mx-auto w-full'
            />
            <div className='flex flex-col gap-5'>
              <div>
                <Typography size='xs' color='text-lighter' weight='medium'>Lot {relatedItem.lotNumber}</Typography>
                <Typography expressive weight='bold' color='text' heading size='sm' className='line-clamp-2'>{relatedItem.webTitle}</Typography>
              </div>
              <Button divButton variant='secondary' className='transition-opacity opacity-0 group-hover:opacity-100 justify-center border-text-lightest'>
                View Lot
              </Button>
            </div>
          </Button>
        ))}
      </div>
      <div className='flex justify-center pt-5'>
        <Button size='lg' variant='secondary' to={`/catalog/${itemInfo?.AuctionID}`}>Show More</Button>
      </div>
    </Grid2>
  </div>);
};
